module.exports = __webpack_public_path__ + "img/logo-dark.78fbfd34.png";